module.exports = "<span class=\"qr-badge {{ currentStatus.colorClass }}\">{{ currentStatus.label }}</span>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/components/status-badge/status-badge.component.html
// module id = ../../../../../src/app/components/status-badge/status-badge.component.html
// module chunks = 3